import styled from 'styled-components';
import { Group, Heading, Modal, spacing, palette } from '@landr/maestro';

export const Header = styled(Modal.Header)`
    ${({ theme }): string => theme.breakpoint('md')`
        display: none;
    `};
`;

export const Title = styled(Heading)`
    font-weight: bold;
    margin-bottom: ${spacing('xs')};

    ${({ theme }): string => theme.breakpoint('md')`

        ${Group.Item}:first-child &:first-child {
            margin: ${spacing('xxl')} 0 ${spacing('lg')} 0;
        }
    `};
`;

export const Content = styled(Modal.Section)`
    padding-top: 0;
    text-align: center;

    button,
    a {
        margin-bottom: ${spacing('xxl')};
        width: 100%;
    }

    a {
        font-weight: bold;
    }
`;

export const Wrapper = styled(Modal.Section)`
    background-color: ${palette('neutral.0')};
    padding: 0;

    /* Adding the style direction to the content breaks because of rules
       with higher specificity overriding it */

    ${Content} {
        width: 100%;
    }

    p + button {
        margin-top: ${spacing('sm')};
    }

    width: 50%;
    ${({ theme }): string => theme.breakpoint('md')`
         width: 100%;
    `}
`;
